import React, { useEffect, useRef, useState } from "react";
import fxmlogo from "../../../assets/icons/fxmedia-logo-white.png";
import startVideoBackground from "../../../assets/classroom/video/classroom_start.mp4";
import ClassroomStartMenu from "../../../component/menu/classroomStartMenu";

const ClassroomStartPage = () => {
  const videoRef = useRef(null);
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  useEffect(() => {
    sessionStorage.clear();
    sessionStorage.setItem("language", "EN");
  }, []);

  window.onload = function () {
    if (!window.location.hash) {
      window.location = window.location + "#loaded";
      window.location.reload();
    }
  };

  useEffect(() => {
    const videoElement = videoRef.current;
    const playVideo = () => {
      videoElement?.play().catch((error) => {
        console.error("Error trying to play video:", error);
      });
    };

    if (videoElement) {
      videoElement.addEventListener("loadeddata", playVideo);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("loadeddata", playVideo);
      }
    };
  }, []);

  const toggleMenuVisibility = () => {
    setIsMenuVisible((prevVisibility) => !prevVisibility);
  };

  const closeMenu = () => {
    setIsMenuVisible(false);
  };

  useEffect(() => {
    const adjustVideoPosition = () => {
      if (window.innerWidth >= 520) {
        if (videoRef.current) {
          videoRef.current.style.position = "relative";
          videoRef.current.style.top = "20px";
        }
      } else {
        if (videoRef.current) {
          videoRef.current.style.position = "static";
          videoRef.current.style.top = "0";
        }
      }
    };

    adjustVideoPosition();
    window.addEventListener("resize", adjustVideoPosition);

    return () => {
      window.removeEventListener("resize", adjustVideoPosition);
    };
  }, []);

  return (
    <div className="classroom__startpage">
      <img src={fxmlogo} alt="fxmlogo" className="logo" />
      <video
        className="background-video"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        ref={videoRef}
        src={startVideoBackground}
        type="video/mp4"
        style={{ objectFit: "cover" }}
      ></video>

      <div
        className="classroom__startpage-button"
        onClick={toggleMenuVisibility}
      >
        <p>Start Now</p>
      </div>

      {isMenuVisible && <ClassroomStartMenu closeMenu={closeMenu} />}
    </div>
  );
};

export default ClassroomStartPage;
